import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, getJwtFromCookies } from "../module_auth/AuthService"
import parse from 'html-react-parser';
import { useNavigate } from "react-router-dom";
import { getUniqFileUrl } from "../component/common/BaseUtil"
import { getTextWorkCity, getUniqLogoUrl, getEmptyLogoUrl, formatDate, sendGoogleAnalytics } from "../component/common/BaseUtil"
import { CheckAndShowLogo } from "../component/common/Logo"
import '../App.css';
import 'react-quill/dist/quill.snow.css';
import { useLocation } from "react-router-dom";

export function Job() {
    const location = useLocation();

    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id");

    //채용상세
    const [objTitle, setObjTitle] = useState("");

    const [cpName, setCpName] = useState("");
    const [cpAddress, setCpAddress] = useState("");
    const [fullname, setFullname] = useState("");
    const [telno, setTelno] = useState("");
    //const [email, setEmail] = useState("");

    // 인사담당자정보
    const [recruiterName, setRecruiterName] = useState("");
    const [recruiterTelno, setRecruiterTelno] = useState("");
    const [recruiterEmail, setRecruiterEmail] = useState("");

    const [regJob, setRegJob] = useState("");
    const [workCity, setWorkCity] = useState("0");

    const [workTime, setWorkTime] = useState("0");
    //근무형태 체크박스
    const [checkedWorktimeFull, setCheckedWorktimeFull] = useState(false);
    const [checkedWorktimePart, setCheckedWorktimePart] = useState(false);
    const [checkedWorktimeMini, setCheckedWorktimeMini] = useState(false);


    const [visaCond, setVisaCond] = useState("");
    //비자조건 체크박스
    const [checkedVisaCondWorking, setCheckedVisaCondWorking] = useState(false);
    const [checkedVisaCondHoli, setCheckedVisaCondHoli] = useState(false);
    const [checkedVisaCondSeek, setCheckedVisaCondSeek] = useState(false);
    const [checkedVisaCondStd, setCheckedVisaCondStd] = useState(false);

    const [applyCond, setApplyCond] = useState("");

    const [cpIntro, setCpIntro] = useState("");
    const [jobDetail, setJobDetail] = useState("");

    const [fileExist, setFileExist] = useState(false);

    const [fileName, setFileName] = useState("");
    const [fileFormat, setFileFormat] = useState("");
    const [uniqFileName, setUniqFileName] = useState("");

    const [logoName, setLogoName] = useState("");
    const [logoFormat, setLogoFormat] = useState("");
    const [uniqLogoName, setUniqLogoName] = useState("");

    const [updateAt, setUpdateAt] = useState("");

    const [cityList, setCityList] = useState([]);
    //End 채용상세

    const [token, setToken] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // 페이지 최상단으로 스크롤
        window.scrollTo(0, 0);

        sendGoogleAnalytics(location.pathname)

        setToken(getJwtFromCookies())
        setIsLoading(true);
        let url = basePort + '/get/job/' + id
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setObjTitle(response.objTitle)
                setCpName(response.cpName)
                setCpAddress(response.cpAddress)
                setJobDetail(response.jobDetail)
                setFullname(response.fullname)
                setTelno(response.telno)

                setRecruiterName(response.recruiterName)
                setRecruiterTelno(response.recruiterTelno)
                setRecruiterEmail(response.recruiterEmail)

                setRegJob(response.regJob)
                setWorkCity(response.workCity)
                //setWorkTime(response.workTime)
                setCheckedWorktimeFull(response.worktimeFull == "t" ? true : false)
                setCheckedWorktimePart(response.worktimePart == "t" ? true : false)
                setCheckedWorktimeMini(response.worktimeMini == "t" ? true : false)

                //setVisaCond(response.visaCond)
                setCheckedVisaCondWorking(response.visaCondWorking == "t" ? true : false)
                setCheckedVisaCondHoli(response.visaCondHoli == "t" ? true : false)
                setCheckedVisaCondSeek(response.visaCondSeek == "t" ? true : false)
                setCheckedVisaCondStd(response.visaCondStd == "t" ? true : false)

                setApplyCond(response.applyCond)
                setCpIntro(response.cpIntro == null ? "" : response.cpIntro)
                setJobDetail(response.jobDetail == null ? "" : response.jobDetail)
                setUpdateAt(response.updateAt)
                if (response.fileName) {
                    setFileName(response.fileName)
                    setFileFormat(response.fileFormat)
                    setUniqFileName(response.uniqFileName)
                    setFileExist(true)
                }
                console.log("response.logoName:" + response.logoName)
                if (response.logoName) {
                    setLogoName(response.logoName)
                    setLogoFormat(response.logoFormat)
                    setUniqLogoName(response.uniqLogoName)
                }

                getCityList()
            }).catch(error => console.log(error))
            .finally(() => {
                setIsLoading(false);
            });
        
        
    }, []);

    let navigate = useNavigate();
    function backToList() {
        let returnTo = queryParameters.get("returnTo");
        let returnPage = localStorage.getItem("page")
        let pageList = returnPage == null ? 1 : returnPage
        let url
        if (returnTo === "/job_list") {
            url = returnTo + "?page=" + pageList;
        } else {
            // home, mypage
            url = returnTo;
        }
        navigate(url);
    }

    function getCityList() {
        let url = basePort + '/get/config'
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setCityList(response.cityEntityList)
            }).catch(error => console.log(error))
    }

    function backToLogin() {
        let url = "/login";
        navigate(url);
    }

    return (
        <div>
            <main class="page lanidng-page" style={{ opacity: isLoading ? 0.45 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}>
                <section>
                    <div className="container responsive-container-width" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <ol class="breadcrumb">
                            <li className="breadcrumb-item"><span>채용정보</span></li>
                            <li className="breadcrumb-item"><span>채용상세</span></li>
                        </ol>
                        <div className="card" >
                            <div className="card-body">
                                <h4 className="card-title"
                                    style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>{objTitle}</h4>
                            </div>
                        </div>
                        <div class="row" style={{ marginBottom: '50px' }}>
                            <label class="form-label"><span style={{ fontSize: '14px', marginLeft: "10px" }}>작성일: {formatDate(updateAt)}</span></label>
                        </div>
                        <h4 style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>근무조건</h4>
                        <div className="card" style={{ marginBottom: '50px' }}>
                            <div className="card-body">
                                <div class="container text-left">
                                    <div class="row g-2">
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3"><span><span style={{ color: "#696969", fontWeight: 'bold' }}>모집부문:</span> {regJob}</span></div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3"><span><span style={{ color: "#696969", fontWeight: 'bold' }}>근무도시:</span> {getTextWorkCity(cityList, workCity)}</span></div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                            <div className="p-3">
                                                <span style={{ color: "#696969", fontWeight: 'bold' }}>근무형태:</span>
                                                <div style={{ marginTop: "5px" }}>
                                                    {/* 세 가지 체크박스 중 하나라도 체크되어 있는지 확인 */}
                                                    {checkedWorktimeFull || checkedWorktimePart || checkedWorktimeMini ? (
                                                        // 하나라도 체크되어 있다면 체크박스 그룹 표시
                                                        <>
                                                            <div className="form-check form-check-inline">
                                                                <input className="form-check-input" type="checkbox" id="worktimeFull" checked={checkedWorktimeFull} readOnly />
                                                                <label className="form-check-label" htmlFor="worktimeFull">풀타임</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input className="form-check-input" type="checkbox" id="worktimePart" checked={checkedWorktimePart} readOnly />
                                                                <label className="form-check-label" htmlFor="worktimePart">파트타임</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input className="form-check-input" type="checkbox" id="worktimeMini" checked={checkedWorktimeMini} readOnly />
                                                                <label className="form-check-label" htmlFor="worktimeMini">미니잡</label>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        // 체크된 항목이 하나도 없다면 텍스트 표시
                                                        <span style={{ color: "#000" }}>회사 내규에 따름</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                            <div className="p-3">
                                                <span>
                                                    <span style={{ color: "#696969", fontWeight: 'bold', marginRight: '10px' }}>비자조건:</span>
                                                    <div style={{ marginTop: "5px" }}>
                                                        {/* 모든 비자 조건 변수가 false일 경우 "지원 시 확인 필요" 표시 */}
                                                        {checkedVisaCondWorking || checkedVisaCondHoli || checkedVisaCondSeek || checkedVisaCondStd ? (
                                                            <>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="checkbox" id="visaCondWorking" checked={checkedVisaCondWorking} readOnly />
                                                                    <label className="form-check-label" htmlFor="visaCondWorking">워킹비자</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="checkbox" id="visaCondHoli" checked={checkedVisaCondHoli} readOnly />
                                                                    <label className="form-check-label" htmlFor="visaCondHoli">워킹홀리데이비자</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="checkbox" id="visaCondSeek" checked={checkedVisaCondSeek} readOnly />
                                                                    <label className="form-check-label" htmlFor="visaCondSeek">취업준비비자</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="checkbox" id="visaCondStd" checked={checkedVisaCondStd} readOnly />
                                                                    <label className="form-check-label" htmlFor="visaCondStd">학생비자</label>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <span style={{ color: "#333" }}>지원 시 확인 필요</span>
                                                        )}
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                        {/* <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3"><span><span style={{color:"#696969", fontWeight: 'bold'}}>지원조건:</span> {applyCond}</span></div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h4 style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>모집상세</h4>
                        <div className="card" style={{ marginBottom: '50px' }}>
                            <div className="card-body ql-editor">
                                {parse(jobDetail)}
                            </div>
                            <div className="container" hidden={!fileExist}>
                                <div className="row">
                                    <a className="link-dark" href={getUniqFileUrl(uniqFileName, fileFormat)}
                                        target="_blank">
                                        <span
                                            style={{ marginLeft: '5px', marginRight: '5px', marginBottom: '5px' }}
                                            className="badge bg-info">파일</span>{fileName}{fileFormat}</a>
                                </div>
                            </div>
                        </div>

                        <h4 style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>기업정보</h4>
                        <div className="card" style={{ marginBottom: '50px' }}>
                            <div className="card-body">
                                <div class="container text-left">
                                    <div class="row g-2" >
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3"><span style={{ color: "#696969", fontWeight: 'bold' }}>회사명:</span> {cpName}</div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6" >
                                            <CheckAndShowLogo
                                                imageUrl={logoName != "" ? getUniqLogoUrl(uniqLogoName, logoFormat) : getEmptyLogoUrl("empty_logo", "png")}
                                                alt="유효한 이미지"
                                                imageAlign="left"
                                                style={{ marginTop: "5px", marginBottom: "5px" }}
                                            />
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3"><span style={{ color: "#696969", fontWeight: 'bold' }}>회사주소:</span> {cpAddress}</div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            {/* <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>대표자명:</span> {fullname}</div> */}
                                        </div>
                                        {/* <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>인사담당자 전화번호:</span> {recruiterTelno}</div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>인사담당자 이메일:</span> {recruiterEmail}</div>
                                        </div> */}
                                        {cpIntro && cpIntro.trim() !== "" && (
                                            <div class="col-sm-12 col-md-12 col-lg-12">
                                                <div class="p-3"><span style={{ color: "#696969", fontWeight: 'bold' }}>회사소개:</span><br />{parse(cpIntro)}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <nav class="d-flex d-md-flex justify-content-center justify-content-md-center"
                        style={{ margintop: '10px' }}>
                        <ul class="pagination">
                            <li class="page-item"><a class="page-link" onClick={backToList}>목록</a></li>
                        </ul>
                    </nav>
                </section>
            </main>
            {isLoading && (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(128, 128, 128, 0.22)',
                        zIndex: 1050
                    }}
                >
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
}